import React, { Component } from 'react';
import { doAdminLogin, setAdminToken } from '../../APICall/Api.jsx';

class AdminLogin extends Component {
  state = { password: '', error: '', loading: false };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ loading: true, error: '' });
    try {
      const res = await doAdminLogin(this.state.password);
      if (res.success && res.token) {
        setAdminToken(res.token);
        this.props.history.push('/admin/dashboard');
      } else {
        this.setState({ error: 'Invalid password. Please try again.', loading: false });
      }
    } catch (e) {
      this.setState({ error: 'Connection error. Please try again.', loading: false });
    }
  };

  render() {
    const { password, error, loading } = this.state;
    return (
      <div className="bgg-login-page">
        <div className="bgg-login-card">
          <div className="bgg-login-logo">
            <div className="bgg-logo-icon">
              <i className="fas fa-leaf" />
            </div>
            <h2>Build Green Group</h2>
            <p>Admin Panel — Secure Access</p>
          </div>

          {error && <div className="bgg-login-error">{error}</div>}

          <form onSubmit={this.handleSubmit}>
            <div className="bgg-form-group">
              <label className="bgg-form-label">Admin Password</label>
              <input
                className="bgg-form-input"
                type="password"
                value={password}
                onChange={(e) => this.setState({ password: e.target.value })}
                placeholder="Enter admin password"
                required
                autoFocus
              />
            </div>
            <button
              type="submit"
              className="bgg-btn bgg-btn-primary"
              style={{ width: '100%', justifyContent: 'center', marginTop: 8 }}
              disabled={loading}
            >
              {loading ? 'Signing in…' : 'Sign In'}
            </button>
          </form>

          <p style={{ textAlign: 'center', marginTop: 24, fontSize: '0.8rem', color: '#8a8aaa' }}>
            <a href="/" style={{ color: '#2e7d32' }}>← Back to main site</a>
          </p>
        </div>
      </div>
    );
  }
}

export default AdminLogin;



// WEBPACK FOOTER //
// ./src/views/Admin/AdminLogin.jsx